import {combineReducers} from "redux";
import {dashboardReducer} from "modules/Metric/services/dashboard/reducer";
import {metricDataCollectionStatusReducer} from "modules/Metric/services/MetricDataCollectionStatus/reducer";
import {keywordScanStatsReducer} from "modules/Metric/services/MetricKeywordScanStats/reducer";

export const metricReducer = combineReducers({
    dashboard: dashboardReducer,
    metricDataCollectionStatus: metricDataCollectionStatusReducer,
    keywordScanStats: keywordScanStatsReducer,
});
